import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';


import CarouselArrow from 'Components/Carousel/CarouselArrow';
import CarouselPaging from 'Components/Carousel/CarouselPaging';
import SkeletonHitCard from 'Components/Cards/SkeletonHitCard';

const SkeletonCarousel = ({
  slidesToShow,
  showFlashDealBar,
}) => {
  let fakeCardCount = 9;

  if (slidesToShow === 4) {
    fakeCardCount = 12;
  }

  const settings = {
    infinite: false,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container" />,
    slidesToShow: slidesToShow || 3,
    slidesToScroll: slidesToShow || 3,
    centerMode: slidesToShow === 1,
    centerPadding: slidesToShow === 1 ? '20px' : '0px',
    dots: true,
    lazyLoad: true,
    initialSlide: 0,
    accessibility: true,
    customPaging: i => (
      <CarouselPaging
        slideIndex={i}
        slideLength={fakeCardCount.length}
        slidesToShow={slidesToShow || 3}
      />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: slidesToShow || 3,
          slidesToScroll: slidesToShow || 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          customPaging: i => (
            <CarouselPaging
              slideIndex={i}
              slideLength={fakeCardCount.length}
              slidesToShow={3}
            />
          ),
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          customPaging: i => (
            <CarouselPaging
              slideIndex={i}
              slideLength={fakeCardCount.length}
              slidesToShow={2}
            />
          ),
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToScroll: 1,
          slidesToShow: 1,
          swipeToSlide: true,
          customPaging: i => (
            <CarouselPaging
              slideIndex={i}
              slideLength={fakeCardCount.length}
              slidesToShow={1}
            />
          ),
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings} className="product-slider">

        {[...Array(fakeCardCount).keys()].map(fakeHit =>
          <SkeletonHitCard
            key={fakeHit + 1}
            numberOfCards={1}
            xsSize={12}
            smSize={12}
            mdSize={12}
            lgSize={12}
            showFlashDealBar={showFlashDealBar}
          />,
        )}
      </Slider>
    </div>
  );
};

SkeletonCarousel.propTypes = {
  slidesToShow: PropTypes.number,
  showFlashDealBar: PropTypes.bool,
};

SkeletonCarousel.defaultProps = {
  slidesToShow: 3,
  showFlashDealBar: false,
};

export default SkeletonCarousel;
